export default "__VITE_ASSET__BkEiRsjF__"